<template>
    <div class="flex flex-col h-screen justify-between">
        <nav id="header" class="fixed w-full z-10 bg-front-color-primary top-0">
            <div id="progress" class="h-1 z-20 top-0" style="background:linear-gradient(to right, #1875ff var(--scroll), transparent 0)"></div>
            <div class="w-full mx-auto flex flex-wrap py-2">
                <div class="flex space-x-4 sm:space-x-8 justify-between items-center w-full mx-6">
                    <a href="/" class="flex items-center space-x-4">
                        <i class="fad fa-home text-white hover:text-sky-500 sm:hidden"></i>
                        <img class="hidden sm:block" style="height:50px !important" src="/assets/img/logo_white.png" />
                    </a>
                    <div class="flex justify-between text-white items-center space-x-4">
                        <front-link-actived title="Tracking" route-link="front.travels.index" />
                        <front-link-actived title="Ma boutique" route-link="front.store.index"
                            active-pattern="front.store.*" color="primaryOrange"
                        />
                        <div v-if="$page.props.user" class="flex items-center space-x-4">
                            <front-link-actived title="Mes colis" route-link="front.packages.show" />
                            <front-link-actived title="Mes articles" route-link="front.items.show" color="primaryOrange" />
                            <front-link-actived title="Mes demandes" route-link="front.requests.show" />
                            <front-link-actived v-if="$page.props.acl.isInternalUser" title="Tableau de bord" route-link="dashboard" :external="true" />
                        </div>
                    </div>
                    <UserMenu v-if="$page.props.user" align="right"
                        :profile-link="$page.props.acl.isInternalUser ? 'profile.show' : 'front.profile.show'"
                    />
                    <a v-else :href="route('login')" class="btn bg-sky hover:bg-sky-400 rounded-full text-white ml-3">
                        Connexion
                    </a>
                </div>
            </div>
        </nav>

        <!--Container-->
	    <main class="container w-ful md:max-w-7xl mx-auto pt-20 px-2">
            <div class="w-full text-xl text-gray-800 leading-normal mt-4">
                <slot />
            </div>
        </main>

        <footer class="w-full bg-front-color-primary border-t border-gray-400 shadow bottom-0">
            <div class="container max-w-7xl mx-auto flex py-4">
                <div class="w-full mx-auto flex flex-wrap">
                    <div class="flex w-full md:w-2/4">
                        <div class="px-8">
                            <h3 class="font-bold text-white">À propos de Boti Cargo Shipping</h3>
                            <p class="py-4 text-gray-400 text-sm">
                                <b v-if="$page.props.contactSettings.address">{{ 'Basée à ' + $page.props.contactSettings.address }}, </b>
                                <b>Boti Cargo Shipping</b> est votre partenaire de confiance pour l'expédition de marchandises entre le Royaume-Uni et la Côte d'Ivoire. Nous prenons en charge l'ensemble de la chaîne logistique afin de garantir un transport rapide, sécurisé et efficace de vos colis, que ce soit de Londres vers la Côte d'Ivoire ou de la Côte d'Ivoire vers Londres.
                            </p>
                        </div>
                    </div>

                    <div v-if="$page.props.contactSettings.facebook_link || $page.props.contactSettings.linkedin_link" class="flex w-full md:w-1/4">
                        <div class="px-8">
                            <h3 class="font-bold text-white">Réseaux sociaux</h3>
                            <ul class="list-reset items-center text-sm pt-3 space-y-2">
                                <li v-if="$page.props.contactSettings.facebook_link">
                                    <a class="inline-block text-sky-500 no-underline hover:text-sky-400 hover:text-underline"
                                        :href="$page.props.contactSettings.facebook_link ? $page.props.contactSettings.facebook_link : '#'" target="_blank"
                                    ><i class="fab fa-facebook"></i> Facebook
                                    </a>
                                </li>
                                <li v-if="$page.props.contactSettings.linkedin_link">
                                    <a class="inline-block text-sky-500 no-underline hover:text-sky-400 hover:text-underline"
                                        :href="$page.props.contactSettings.linkedin_link ? $page.props.contactSettings.linkedin_link : '#'" target="_blank"><i class="fab fa-linkedin"></i> LinkedIn
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div v-if="$page.props.contactSettings.phone || $page.props.contactSettings.email" class="flex w-full md:w-1/4">
                        <div class="px-8">
                            <h3 class="font-bold text-white">Coordonnées</h3>
                            <ul class="list-reset items-center text-sm pt-3 space-y-2">
                                <li v-if="$page.props.contactSettings.phone"
                                    class="inline-block text-sky-500 no-underline hover:text-sky-400 hover:text-underline"
                                >
                                    <a :href="'tel:' + $page.props.contactSettings.dial_code + $page.props.contactSettings.phone" target="_blank">
                                        <i class="fas fa-phone"></i> {{ '+'+ $page.props.contactSettings.dial_code + $page.props.contactSettings.phone }}
                                    </a>
                                </li>
                                <li v-if="$page.props.contactSettings.email"
                                    class="inline-block text-sky-500 no-underline hover:text-sky-400 hover:text-underline"
                                >
                                    <a :href="'mailto:' + $page.props.contactSettings.email" target="_blank">
                                        <i class="fas fa-envelope"></i> {{ $page.props.contactSettings.email }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
    import { defineComponent, nextTick } from 'vue'
    import UserMenu from '@/Components/DropdownProfile.vue'
    import FrontLinkActived from '@/Components/FrontLinkActived'

    export default defineComponent({
        components: {
            UserMenu,
            FrontLinkActived
        },

        mounted() {
            this.$nextTick(function() {
                var h = document.documentElement,
                b = document.body,
                    st = 'scrollTop',
                    sh = 'scrollHeight',
                    progress = document.querySelector('#progress'),
                    scroll;
                var scrollpos = window.scrollY;
                var header = document.getElementById("header");

                document.addEventListener('scroll', function() {

                    /*Refresh scroll % width*/
                    scroll = (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100;
                    progress.style.setProperty('--scroll', scroll + '%');

                    /*Apply classes for slide in bar*/
                    scrollpos = window.scrollY;

                    if (scrollpos > 10) {
                        header.classList.add("shadow");
                    } else {
                        header.classList.remove("shadow");
                    }
                });
            })
        }
    })
</script>
